<template>
    <div class="structure-filters">
        <label class="structure-filters__field structure-filters__field--search">
            <span class="visually-hidden">Поиск по названию</span>
            <input
                v-model.trim="searchQuery"
                type="search"
                class="form-input"
                placeholder="Поиск: партнёр, рекламодатель, бренд, кампания"
            />
        </label>
        <label v-if="partners.length > 1" class="structure-filters__field">
            <span class="structure-filters__label">Партнёр</span>
            <select v-model="partnerId" class="select-input">
                <option value="">Все</option>
                <option v-for="partner in partners" :key="partner.id" :value="String(partner.id)">
                    {{ partner.name }}
                </option>
            </select>
        </label>
        <div class="structure-filters__links">
            <button type="button" class="structure-filters__link" @click="emit('expand-all')">Развернуть всё</button>
            <button type="button" class="structure-filters__link" @click="emit('collapse-all')">Свернуть всё</button>
            <button v-if="hasActiveFilters" type="button" class="structure-filters__link" @click="reset">Сбросить</button>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

defineProps({
    partners: { type: Array, required: true },
});

const emit = defineEmits(['expand-all', 'collapse-all']);

const searchQuery = defineModel('searchQuery', { type: String, default: '' });
const partnerId = defineModel('partnerId', { type: String, default: '' });

const hasActiveFilters = computed(() => Boolean(searchQuery.value || partnerId.value));

const reset = () => {
    searchQuery.value = '';
    partnerId.value = '';
};
</script>

<style scoped lang="scss">
@use '../../../../scss/pages/admin/admin-tokens' as *;

.structure-filters {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: $spacing-md;
    flex: 1 1 auto;
    min-width: 0;
}

.structure-filters__field {
    display: inline-flex;
    align-items: center;
    gap: $spacing-sm;
    margin: 0;

    &--search {
        flex: 1 1 280px;
        max-width: 420px;

        .form-input { padding: 0.4rem $spacing-md; }
    }
}

.structure-filters__label {
    font-size: $font-size-sm;
    color: $admin-text-muted;
}

.structure-filters__links {
    display: inline-flex;
    flex-wrap: wrap;
    gap: $spacing-md;
}

.structure-filters__link {
    border: none;
    background: none;
    padding: 0;
    font-size: $font-size-sm;
    color: $admin-primary-color;
    cursor: pointer;

    &:hover { text-decoration: underline; }
}

.visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
}
</style>
